import { useEffect, useState } from 'react';
import { useAppSelector } from '@application/store/useStore';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import TimeSheetApi from '@infrastructure/timeSheet-api';
import DocumentApi from '@infrastructure/document-api';
const MAX_AGE_MS = 60_000;
let cache = null;
const load = (userId) => Promise.all([
    TimeSheetApi.getTimeSheetCountsByStatus()
        .then((response) => response.data)
        .catch(() => undefined),
    DocumentApi.getAssignmentsAndUserDocuments()
        .then((response) => Array.isArray(response.data?.assignmentDocumentsLst)
        ? response.data.assignmentDocumentsLst.filter((document) => document.status === ClientContractStatus.PendingSignature).length
        : undefined)
        .catch(() => undefined)
]).then(([timeSheetCounts, documentsToSign]) => ({ userId, timeSheetCounts, documentsToSign }));
const readCount = (counts, key) => {
    if (!counts)
        return undefined;
    const value = Object.entries(counts).find(([status]) => status === key)?.[1];
    return typeof value === 'number' ? value : 0;
};
export const useFreelancerTaskCounts = (refreshKey) => {
    const userId = useAppSelector((state) => state.auth.currentUser?.id);
    const storeCounts = useAppSelector((state) => state.timeSheet.timeSheetsCount);
    const [snapshot, setSnapshot] = useState(undefined);
    useEffect(() => {
        if (!userId) {
            cache = null;
            setSnapshot(undefined);
            return;
        }
        let active = true;
        if (!cache || cache.userId !== userId || Date.now() - cache.startedAt > MAX_AGE_MS) {
            cache = { userId, startedAt: Date.now(), promise: load(userId) };
        }
        cache.promise.then((value) => {
            if (active)
                setSnapshot(value);
        });
        return () => {
            active = false;
        };
    }, [userId, refreshKey]);
    const own = snapshot && snapshot.userId === userId ? snapshot : undefined;
    const timeSheetCounts = storeCounts ?? own?.timeSheetCounts;
    return {
        openTimeSheets: readCount(timeSheetCounts, 'Open'),
        rejectedTimeSheets: readCount(timeSheetCounts, 'Rejected'),
        documentsToSign: own?.documentsToSign,
        isLoaded: own !== undefined
    };
};
